import React, {useContext} from 'react';
import {KatBox, KatExpander} from "@amzn/katal-react";
import {HEALTH_EVENT} from "src/common/constants/constants";
import {IEvent} from "src/context/models/Event";
import {GlobalContext} from "src/context/GlobalProvider";
import {HistoricalEventCard} from "src/components/healthDashboard/HistoricalEventCard";

type Props = {
    events: IEvent[]
};

export const HistoricalStatus: React.FC<Props> = ({
                                                      events
                                                  }) => {
    const {sessionState} = useContext(GlobalContext);
    const region = sessionState.data.region

    const populateHistory = (events: IEvent[]) => {
        const closedEvents = events.filter(healthEvent => !!healthEvent.end
            && healthEvent.region == region
            && healthEvent.type == HEALTH_EVENT
            && !healthEvent.operation)
            // @ts-ignore
            .sort((a, b) => b.end - a.end);

        return (closedEvents.map(healthEvent => <HistoricalEventCard event={healthEvent}
                                                                     key={healthEvent.lastUpdatedAt}/>))
    };

    return (
        <>
            <KatBox id="historical-status" variant="azure">
                <KatExpander id="status-history" label="Past Incidents - Last 30 days">
                    {populateHistory(events)}
                </KatExpander>
            </KatBox>
        </>
    );
}
